import { isArrayLike, isSet, isMap } from 'lodash-es';

import { Dictionary } from '@bp/shared/typings';

import { isObjectLike } from './lodash-wrappers';

export function isDictionaryObject(value: unknown): value is Dictionary<unknown> {
	return isObjectLike(value) && !isArrayLike(value) && !isSet(value) && !isMap(value);
}
